import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import ActionButtons from "../../components/action_buttons";
import * as Yup from "yup";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { axiosApi } from "../../../services/axios_api";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";

const EditAddForm = ({
  onHide,
  editable,
  setRes,
  rowData,
  setShowDialog,
  getKiosksData,
}) => {
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState([]);
  const [branch, setBranchs] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState({
    district: "",
    region: "",
    area: "",
  });
  console.log("selectedBranch", selectedBranch);
  useEffect(() => {
    const fetchBranches = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(`/Portal/lists/branches`);
        setBranchs(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };
    const fetchTechnicians = async () => {
      setLoading(true);
      try {
        const response = await axiosApi.get(`/Portal/lists/users/technicians`);
        setTechnicians(response.data.body);
      } catch (error) {
        toast.error("Failed to fetch data.");
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
    fetchTechnicians();
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required."),
    ipAddress: Yup.string().required("IP Address is required."),
    location: Yup.string().required("Location is required."),
    cashAcceptorCapacity: Yup.string().required(
      "Cash Acceptor Capacity is required."
    ),
    alertThreshold: Yup.string().required("Alert Threshold is required."),
    warningLevelInput: Yup.string().required(
      "Warning Level Input is required."
    ),
    remarks: Yup.string().required("Remarks is required."),
    status: Yup.string().required("Status is required."),
    softwareVersion: Yup.string().required("Software Version is required."),
    connectivityStatus: Yup.string().required(
      "Connectivity Status is required."
    ),
    healthStatus: Yup.string().required("Health Status is required."),
    receiptsPrinterStatus: Yup.string().required(
      "Receipts Printer Status is required."
    ),
    singleTransactionLimit: Yup.string().required(
      "Single Transaction Limit is required."
    ),
    dailyTransactionLimit: Yup.string().required(
      "Daily Transaction Limit is required."
    ),
    cardsAvailable: Yup.string().required("Cards Available is required."),
    cardsCapacity: Yup.string().required("Cards Capacity is required."),
    branchId: Yup.string().required("Please select Branch."),
    technicianId: Yup.string().required("Please select Technician."),
    operationTimeStart: Yup.date().required(
      "Operation Start Time is required."
    ),
    // operationTimeEnd: Yup.string().required("Operation End Time is required."),
    operationTimeEnd: Yup.date()
      .required("Operation End Time is required")
      .test(
        "is-after-start",
        "Operation End Time must be after Start Time",
        function (value) {
          const { operationTimeStart } = this.parent;
          if (!operationTimeStart || !value) return true;
          return (
            new Date(value).getTime() > new Date(operationTimeStart).getTime()
          );
        }
      ),
    maintenanceTimeStart: Yup.date().required(
      "Maintenance Start Time is required."
    ),
    // maintenanceTimeEnd: Yup.string().required(
    //   "Maintenance End Time is required."
    // ),
    maintenanceTimeEnd: Yup.date()
      .required("Maintenance End Time is required")
      .test(
        "is-after-start",
        "Maintenance End Time must be after Start Time",
        function (value) {
          const { maintenanceTimeStart } = this.parent;
          if (!maintenanceTimeStart || !value) return true;
          return (
            new Date(value).getTime() > new Date(maintenanceTimeStart).getTime()
          );
        }
      ),
    currencyDenomination: Yup.string().required(
      "Currency Denomination is required."
    ),
  });

  // console.log(rowData);

  const formik = useFormik({
    initialValues: {
      name: rowData?.name || "",
      ipAddress: rowData?.ipAddress || "",
      location: rowData?.location || "",
      cashAcceptorCapacity: rowData?.cashAcceptorCapacity || "",
      alertThreshold: rowData?.alertThreshold || "",
      warningLevelInput: rowData?.warningLevelInput || "",
      softwareVersion: rowData?.softwareVersion || "",
      remarks: rowData?.remarks || "",
      status: rowData?.status || "",
      connectivityStatus: rowData?.connectivityStatus || "",
      healthStatus: rowData?.healthStatus || "",

      receiptsPrinterStatus: rowData?.receiptsPrinterStatus || "",
      singleTransactionLimit: rowData?.singleTransactionLimit || "",
      dailyTransactionLimit: rowData?.dailyTransactionLimit || "",
      cardsAvailable: rowData?.cardsAvailable || "",
      cardsCapacity: rowData?.cardsCapacity || "",
      branchId: rowData?.branchId || "",
      technicianId: rowData?.technicianId || "",
      // operationTimeStart: rowData?.operationTimeStart || "",
      operationTimeStart: rowData?.operationTimeStart
        ? new Date(`1970-01-01T${rowData.operationTimeStart}`)
        : "",
      operationTimeEnd: rowData?.operationTimeEnd
        ? new Date(`1970-01-01T${rowData.operationTimeEnd}`)
        : "",
      maintenanceTimeStart: rowData?.maintenanceTimeStart
        ? new Date(`1970-01-01T${rowData.maintenanceTimeStart}`)
        : "",
      maintenanceTimeEnd: rowData?.maintenanceTimeEnd
        ? new Date(`1970-01-01T${rowData.maintenanceTimeEnd}`)
        : "",

      currencyDenomination: rowData?.currencyDenomination || "",
    },
    validationSchema,
    onSubmit: async (data) => {
      setLoading(true);
      try {
        const formattedData = {
          ...data,
          operationTimeStart: data.operationTimeStart
            ? data.operationTimeStart.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null,
          operationTimeEnd: data.operationTimeEnd
            ? data.operationTimeEnd.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null,
          maintenanceTimeStart: data.maintenanceTimeStart
            ? data.maintenanceTimeStart.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null,
          maintenanceTimeEnd: data.maintenanceTimeEnd
            ? data.maintenanceTimeEnd.toLocaleTimeString("en-GB", {
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
              })
            : null,
        };

        let response;
        if (editable) {
          data.id = rowData.id;
          response = await axiosApi.put("/Portal/users/edit", formattedData);
        } else {
          response = await axiosApi.post("/Portal/kiosks/add", formattedData);
        }

        console.log("API Response:", response.data);

        if (response.data.responseCode === "200") {
          toast.success(response.data?.responseDescription);
        } else {
          toast.error(
            response.data?.responseDescription || "Something went wrong"
          );
        }
        setRes(response);
        setShowDialog(false);
      } catch (error) {
        toast.error(
          error.response?.data?.message ||
            "An error occurred. Please try again."
        );
      } finally {
        setLoading(false);
      }
    },
  });
  const handleOpenMap = () => {
    const location = formik.values.location;
    if (location) {
      const googleMapsUrl = `https://www.google.com/maps/search/?q=${encodeURIComponent(
        location
      )}`;
      window.open(googleMapsUrl, "_blank");
    } else {
      toast.warning("Please enter a location first.");
    }
  };
  const status = [
    { label: "Active", value: "Active" },
    { label: "In-Active", value: "In-Active" },
    { label: "Maintenance", value: "Maintenance" },
  ];

  const healthStatus = [
    { label: "Good", value: "Good" },
    { label: "Offline", value: "Offline" },
    { label: "Warnings", value: "Warnings" },
  ];
  const connectivityStatus = [
    { label: "Offline", value: "Offline" },
    { label: "Online", value: "Online" },
  ];
  const PrinterStatus = [
    { label: "Offline", value: "Offline" },
    { label: "Online", value: "Online" },
  ];
  const currencyDenomination = [
    { label: "50", value: "50" },
    { label: "100", value: "100" },
    { label: "500", value: "500" },
    { label: "1000", value: "1000" },
    { label: "5000", value: "5000" },
  ];

  const handleBranchChange = (e) => {
    const selectedBranch = branch.find((b) => b.id === e.value);

    if (selectedBranch) {
      formik.setFieldValue("branchId", e.value);
      setSelectedBranch({
        district: selectedBranch.district,
        region: selectedBranch.region,
        area: selectedBranch.area,
      });
    }
  };

  const setTimeWithBaseDate = (time) => {
    if (!time) return null;
    const baseDate = new Date(); // Today’s date
    return new Date(
      baseDate.setHours(time.getHours(), time.getMinutes(), 0, 0)
    );
  };
  return (
    <div className="main-form">
      <form onSubmit={formik.handleSubmit}>
        <div className="p-fluid formgrid grid">
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Name <span className="text-danger"> *</span>
            </label>
            <InputText
              // keyfilter={/^[a-zA-Z\s]*$/}
              id="name"
              name="name"
              maxLength={"30"}
              value={formik.values.name}
              placeholder="Enter Name"
              onChange={formik.handleChange}
            />
            {formik.touched.name && formik.errors.name && (
              <small className="p-error">{formik.errors.name}</small>
            )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Location <span className="text-danger"> *</span>
            </label>
            <div className="p-inputgroup flex-1 map-search">
              <InputText
                placeholder="Enter Location"
                maxLength={"100"}
                id="location"
                name="location"
                value={formik.values.location}
                onChange={formik.handleChange}
              />
              <Button
                icon="pi pi-search"
                onClick={handleOpenMap}
                type="button"
              />
            </div>
            {formik.touched.location && formik.errors.location && (
              <small className="p-error">{formik.errors.location}</small>
            )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Branch <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="branchId"
              name="branchId"
              value={formik.values.branchId}
              onChange={handleBranchChange}
              options={branch.map((branch) => ({
                label: branch.name,
                value: branch.id,
              }))}
              placeholder="Select Branch"
            />
            {formik.touched.branchId && formik.errors.branchId && (
              <small className="p-error">{formik.errors.branchId}</small>
            )}
          </div>
          {selectedBranch.district &&
            selectedBranch.region &&
            selectedBranch.area && (
              <>
                <div className="field col-12 md:col-4">
                  <label htmlFor="district">District</label>
                  <InputText
                    id="district"
                    value={selectedBranch.district}
                    readOnly
                  />
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="region">Region</label>
                  <InputText
                    id="region"
                    value={selectedBranch.region}
                    readOnly
                  />
                </div>

                <div className="field col-12 md:col-4">
                  <label htmlFor="area">Area</label>
                  <InputText id="area" value={selectedBranch.area} readOnly />
                </div>
              </>
            )}
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              IP Address <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9.]*$/}
              placeholder="Enter IP Address"
              maxLength={15}
              id="ipAddress"
              name="ipAddress"
              value={formik.values.ipAddress}
              onChange={formik.handleChange}
            />
            {formik.touched.ipAddress && formik.errors.ipAddress && (
              <small className="p-error">{formik.errors.ipAddress}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Operation Start Time <span className="text-danger"> *</span>
            </label>
            <Calendar
              placeholder="Enter Operation Start Time"
              id="operationTimeStart"
              name="operationTimeStart"
              value={formik.values.operationTimeStart}
              onChange={(e) => {
                formik.setFieldValue("operationTimeStart", e.value);
              }}
              hourFormat="24"
              timeOnly
            />
            {formik.touched.operationTimeStart &&
              formik.errors.operationTimeStart && (
                <small className="p-error">
                  {formik.errors.operationTimeStart}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Operation End Time <span className="text-danger"> *</span>
            </label>
            <Calendar
              placeholder="Enter Operation End Time"
              id="operationTimeEnd"
              name="operationTimeEnd"
              value={formik.values.operationTimeEnd}
              onChange={(e) => {
                formik.setFieldValue("operationTimeEnd", e.value);
              }}
              hourFormat="24"
              timeOnly
            />

            {formik.touched.operationTimeEnd &&
              formik.errors.operationTimeEnd && (
                <small className="p-error">
                  {formik.errors.operationTimeEnd}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Maintenance Start Time <span className="text-danger"> *</span>
            </label>
            <Calendar
              placeholder="Enter Maintenance Start Time"
              id="maintenanceTimeStart"
              name="maintenanceTimeStart"
              value={formik.values.maintenanceTimeStart}
              onChange={(e) =>
                formik.setFieldValue("maintenanceTimeStart", e.value)
              }
              hourFormat="24"
              timeOnly
            />
            {formik.touched.maintenanceTimeStart &&
              formik.errors.maintenanceTimeStart && (
                <small className="p-error">
                  {formik.errors.maintenanceTimeStart}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Maintenance End Time <span className="text-danger"> *</span>
            </label>
            <Calendar
              placeholder="Enter Maintenance End Time"
              id="maintenanceTimeEnd"
              name="maintenanceTimeEnd"
              value={formik.values.maintenanceTimeEnd}
              onChange={(e) =>
                formik.setFieldValue("maintenanceTimeEnd", e.value)
              }
              hourFormat="24"
              timeOnly
            />
            {formik.touched.maintenanceTimeEnd &&
              formik.errors.maintenanceTimeEnd && (
                <small className="p-error">
                  {formik.errors.maintenanceTimeEnd}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Software Version <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9.]*$/} //numberic with dots
              placeholder="Enter Software Version"
              maxLength={"10"}
              id="softwareVersion"
              name="softwareVersion"
              value={formik.values.softwareVersion}
              onChange={formik.handleChange}
            />
            {formik.touched.softwareVersion &&
              formik.errors.softwareVersion && (
                <small className="p-error">
                  {formik.errors.softwareVersion}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Technician <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="technicianId"
              name="technicianId"
              value={formik.values.technicianId}
              onChange={formik.handleChange}
              options={technicians.map((technicians) => ({
                label: technicians.name,
                value: technicians.id,
              }))}
              placeholder="Select Branch"
            />
            {formik.touched.technicianId && formik.errors.technicianId && (
              <small className="p-error">{formik.errors.technicianId}</small>
            )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Warning Level Input <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/} 
              placeholder="Enter Warning Level Input"
              maxLength="3"
              id="warningLevelInput"
              name="warningLevelInput"
              value={formik.values.warningLevelInput}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("warningLevelInput", value);
              }}
            />

            {formik.touched.warningLevelInput &&
              formik.errors.warningLevelInput && (
                <small className="p-error">
                  {formik.errors.warningLevelInput}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Cash Acceptor Capacity <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter Cash Acceptor Capacity"
              maxLength={"6"}
              id="cashAcceptorCapacity"
              name="cashAcceptorCapacity"
              value={formik.values.cashAcceptorCapacity}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("cashAcceptorCapacity", value);
              }}
            />
            {formik.touched.cashAcceptorCapacity &&
              formik.errors.cashAcceptorCapacity && (
                <small className="p-error">
                  {formik.errors.cashAcceptorCapacity}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Alert Threshold <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter Alert Threshold"
              maxLength={"3"}
              id="alertThreshold"
              name="alertThreshold"
              value={formik.values.alertThreshold}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("alertThreshold", value);
              }}
            />
            {formik.touched.alertThreshold && formik.errors.alertThreshold && (
              <small className="p-error">{formik.errors.alertThreshold}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Cards Capacity <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter Cards Capacity"
              maxLength={"5"}
              id="cardsCapacity"
              name="cardsCapacity"
              value={formik.values.cardsCapacity}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("cardsCapacity", value);
              }}
            />
            {formik.touched.cardsCapacity && formik.errors.cardsCapacity && (
              <small className="p-error">{formik.errors.cardsCapacity}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Cards Available <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter Cards Available"
              maxLength={"5"}
              id="cardsAvailable"
              name="cardsAvailable"
              value={formik.values.cardsAvailable}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("cardsAvailable", value);
              }}
            />
            {formik.touched.cardsAvailable && formik.errors.cardsAvailable && (
              <small className="p-error">{formik.errors.cardsAvailable}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Daily Transaction Limit <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter Daily Transaction Limit"
              maxLength={"7"}
              id="dailyTransactionLimit"
              name="dailyTransactionLimit"
              value={formik.values.dailyTransactionLimit}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("dailyTransactionLimit", value);
              }}
            />
            {formik.touched.dailyTransactionLimit &&
              formik.errors.dailyTransactionLimit && (
                <small className="p-error">
                  {formik.errors.dailyTransactionLimit}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Single Transaction Limit <span className="text-danger"> *</span>
            </label>
            <InputText
              keyfilter={/^[0-9]*$/}
              placeholder="Enter  Single Transaction Limit "
              maxLength={"5"}
              id="singleTransactionLimit"
              name="singleTransactionLimit"
              value={formik.values.singleTransactionLimit}
              onChange={(e) => {
                let value = e.target.value.replace(/^0+/, ""); 
                formik.setFieldValue("singleTransactionLimit", value);
              }}
            />
            {formik.touched.singleTransactionLimit &&
              formik.errors.singleTransactionLimit && (
                <small className="p-error">
                  {formik.errors.singleTransactionLimit}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Receipts Printer Status <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="receiptsPrinterStatus"
              name="receiptsPrinterStatus"
              value={formik.values.receiptsPrinterStatus}
              onChange={formik.handleChange}
              options={PrinterStatus}
              placeholder="Select Receipts Printer Status "
            />
            {formik.touched.receiptsPrinterStatus &&
              formik.errors.receiptsPrinterStatus && (
                <small className="p-error">
                  {formik.errors.receiptsPrinterStatus}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Currency Denomination <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="currencyDenomination"
              name="currencyDenomination"
              value={formik.values.currencyDenomination}
              onChange={formik.handleChange}
              options={currencyDenomination}
              placeholder="Select   Currency Denomination  "
            />
            {formik.touched.currencyDenomination &&
              formik.errors.currencyDenomination && (
                <small className="p-error">
                  {formik.errors.currencyDenomination}
                </small>
              )}
          </div>
          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Status <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="status"
              name="status"
              value={formik.values.status}
              onChange={formik.handleChange}
              options={status}
              placeholder="Select Status "
            />
            {formik.touched.status && formik.errors.status && (
              <small className="p-error">{formik.errors.status}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Health Status <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="healthStatus"
              name="healthStatus"
              value={formik.values.healthStatus}
              onChange={formik.handleChange}
              options={healthStatus}
              placeholder="Select Health Status "
            />
            {formik.touched.healthStatus && formik.errors.healthStatus && (
              <small className="p-error">{formik.errors.healthStatus}</small>
            )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="companyName">
              Connectivity Status <span className="text-danger"> *</span>
            </label>
            <Dropdown
              filter
              id="connectivityStatus"
              name="connectivityStatus"
              value={formik.values.connectivityStatus}
              onChange={formik.handleChange}
              options={connectivityStatus}
              placeholder="Select Connectivity Status "
            />
            {formik.touched.connectivityStatus &&
              formik.errors.connectivityStatus && (
                <small className="p-error">
                  {formik.errors.connectivityStatus}
                </small>
              )}
          </div>

          <div className="field col-12 md:col-4">
            <label htmlFor="feeName">
              Remarks <span className="text-danger"> *</span>
            </label>
            <InputText
              placeholder="Enter Remarks"
              maxLength={"30"}
              id="remarks"
              name="remarks"
              value={formik.values.remarks}
              onChange={formik.handleChange}
            />
            {formik.touched.remarks && formik.errors.remarks && (
              <small className="p-error">{formik.errors.remarks}</small>
            )}
          </div>
        </div>

        <div className="form-buttons mt-4">
          <ActionButtons
            loading={loading}
            onCancel={onHide}
            onSave={formik.handleSubmit}
            saveLabel={editable ? "Update Changes" : "Save Changes"}
            showSave={true}
            cancelLabel="Cancel"
          />
        </div>
      </form>
    </div>
  );
};

export default EditAddForm;
